let navigate;

export const setNavigator = (nav) => {
  navigate = nav;
};

export const goToLogin = () => {
  if (navigate) navigate("/auth/login");
};

/** The firm requires 2FA and the user has not set it up yet (OL-157). */
export const goTo2faSetup = () => {
  if (navigate) navigate("/account/security/overview");
};

export const goTo403 = () => {
  if (navigate) navigate("/error/403");
};